import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaConditionalSchema } from '@common/validation/utils/getTextAreaConditionalSchema';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPostDietConsultReportData = {
    assets: ProcessActivityAsset[];
    bijzonderheden: boolean | null;
    bijzonderheden_omschrijving: string | null;
    datum_consult: string | null;
    verslag_consult: string | null;
};

const bariPostDietConsultReportFinal: TypedSchema<BariPostDietConsultReportData> = {
    assets: getProcessActivityAssetsSchema(),
    bijzonderheden: Koi.boolean(),
    bijzonderheden_omschrijving: getTextAreaConditionalSchema('bijzonderheden'),
    datum_consult: Koi.koi().todayOrBefore(),
    verslag_consult: getTextAreaStringSchema(),
};

const bariPostDietConsultReportDraft: TypedSchema<BariPostDietConsultReportData> = addAllowNull(
    bariPostDietConsultReportFinal,
    ['assets']
);

export const bariPostDietConsultReportDraftSchema = Koi.object(bariPostDietConsultReportDraft);
export const bariPostDietConsultReportFinalSchema = Koi.object(bariPostDietConsultReportFinal);

export type BariPostDietConsultReportReadKey = keyof BariPostDietConsultReportData;

export type BariPostDietConsultReportReadLabel =
    | 'Bestand(en)'
    | 'Bijzonderheden'
    | 'Datum consult'
    | 'Omschrijving bijzonderheden'
    | 'Verslag consult';

export const bariPostDietConsultReportReadSchema: TypedReadSchema<
    BariPostDietConsultReportReadKey,
    BariPostDietConsultReportReadLabel
>[] = [
    {
        items: [
            {
                key: 'datum_consult',
                label: 'Datum consult',
                type: 'dateAsString',
            },
            {
                key: 'verslag_consult',
                label: 'Verslag consult',
            },
            {
                key: 'bijzonderheden',
                label: 'Bijzonderheden',
                type: 'boolean',
            },
            {
                key: 'bijzonderheden_omschrijving',
                label: 'Omschrijving bijzonderheden',
            },
            {
                key: 'assets',
                label: 'Bestand(en)',
            },
        ],
    },
];
